// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили для всех мини-игр в Arcade */

/* Фон оверлея для мини-игр */
.mafia-overlay-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}

/* --- INTRO SCREEN (ПАПКА С ДЕЛОМ) --- */
.mafia-minigame-intro {
  text-align: center;
  color: #333;
  background: #fdf6e3; /* Цвет бумаги */
  padding: 30px;
  width: 280px;
  border-radius: 4px;
  box-shadow:
    0 1px 4px rgba(0,0,0,0.3),
    0 0 0 10px rgba(0,0,0,0.1); /* Эффект папки */
  transform: rotate(-1deg);
  position: relative;
}

/* Штамп "СЕКРЕТНО" */
.intro-stamp {
  position: absolute;
  top: 10px;
  right: 10px;
  border: 3px solid #c0392b;
  color: #c0392b;
  padding: 5px 10px;
  font-weight: 900;
  font-size: 18px;
  transform: rotate(15deg);
  opacity: 0.8;
}

.intro-title {
  font-size: 22px;
  font-weight: 800;
  color: #2c3e50;
  margin-top: 20px;
  margin-bottom: 15px;
  text-transform: uppercase;
  border-bottom: 2px solid #2c3e50;
  padding-bottom: 5px;
  display: inline-block;
}

.intro-desc {
  font-size: 15px;
  color: #555;
  line-height: 1.5;
  margin-bottom: 25px;
  font-family: 'Times New Roman', serif;
}

/* --- Песочные часы (Иконка) --- */
.hourglass-icon {
  font-size: 48px;
  color: #2c3e50;
  opacity: 0.8;
  /* Медленное вращение */
  animation: slowSpin 3s linear infinite;
}

@keyframes slowSpin {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; } to { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/ui/ArcadeShared.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB,EAAE,gBAAgB;EACrC,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB;;8BAE4B,EAAE,iBAAiB;EAC/C,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,MAAM,yBAAyB,EAAE;EACjC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE;AACxC","sourcesContent":["/* Общие стили для всех мини-игр в Arcade */\r\n\r\n/* Фон оверлея для мини-игр */\r\n.mafia-overlay-bg {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 5000;\r\n}\r\n\r\n/* --- INTRO SCREEN (ПАПКА С ДЕЛОМ) --- */\r\n.mafia-minigame-intro {\r\n  text-align: center;\r\n  color: #333;\r\n  background: #fdf6e3; /* Цвет бумаги */\r\n  padding: 30px;\r\n  width: 280px;\r\n  border-radius: 4px;\r\n  box-shadow:\r\n    0 1px 4px rgba(0,0,0,0.3),\r\n    0 0 0 10px rgba(0,0,0,0.1); /* Эффект папки */\r\n  transform: rotate(-1deg);\r\n  position: relative;\r\n}\r\n\r\n/* Штамп \"СЕКРЕТНО\" */\r\n.intro-stamp {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  border: 3px solid #c0392b;\r\n  color: #c0392b;\r\n  padding: 5px 10px;\r\n  font-weight: 900;\r\n  font-size: 18px;\r\n  transform: rotate(15deg);\r\n  opacity: 0.8;\r\n}\r\n\r\n.intro-title {\r\n  font-size: 22px;\r\n  font-weight: 800;\r\n  color: #2c3e50;\r\n  margin-top: 20px;\r\n  margin-bottom: 15px;\r\n  text-transform: uppercase;\r\n  border-bottom: 2px solid #2c3e50;\r\n  padding-bottom: 5px;\r\n  display: inline-block;\r\n}\r\n\r\n.intro-desc {\r\n  font-size: 15px;\r\n  color: #555;\r\n  line-height: 1.5;\r\n  margin-bottom: 25px;\r\n  font-family: 'Times New Roman', serif;\r\n}\r\n\r\n/* --- Песочные часы (Иконка) --- */\r\n.hourglass-icon {\r\n  font-size: 48px;\r\n  color: #2c3e50;\r\n  opacity: 0.8;\r\n  /* Медленное вращение */\r\n  animation: slowSpin 3s linear infinite;\r\n}\r\n\r\n@keyframes slowSpin {\r\n  0% { transform: rotate(0deg); }\r\n  50% { transform: rotate(180deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; } to { opacity: 1; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
